<div class="side-nav-link"
     (click)="onItemSelected(item)"
     [ngStyle]="{'padding-left': (depth * 48) + 'px'}"
     [ngClass]="{'expanded': expanded,'active':active}">


  <!-- Nav Icon-->
  <mat-icon class="icon"
            *ngIf="item.iconName">{{item.iconName}}</mat-icon>

  <!--  Menu Item Name-->
  <div class="nav-link-text">{{item.displayName|translate}}</div>

  <!--  Expand More -->
  <mat-icon class="chevron-icon"
            color="primary"
            *ngIf="item.children && item.children.length"
            [@indicatorRotate]="expanded ? 'expanded': 'collapsed'">
    expand_more
  </mat-icon>
</div>


<ng-container *ngIf="expanded">
  <btx-side-nav-link *ngFor="let child of item.children"
                     [item]="child"
                     [depth]="depth+1">
  </btx-side-nav-link>
</ng-container>
